import { Tab as AntdTab } from "@empglabs/backoffice-ui-kit"

const Tab = props => {
  return <AntdTab {...props} />
}

export default Tab
